import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type ChildModalComponentState, type ChildModalTab} from 'web-app/react/profile/child-profile/child-modal/types';

interface ModalConfig {
    initialState?: ChildModalComponentState;
    availableTabs?: ChildModalTab[];
}

const domain = 'MODALS/CHILD_PROFILE';
export const {action: show} = createAction(`${domain}/SHOW`, (childId: string, config?: ModalConfig) => ({
    childId,
    config,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
